export default {
    en: "English",
    de: "Deutsch",
    es: "Español",
    pt: "Português",
  }